import { render, staticRenderFns } from "./MealrequestEdit.vue?vue&type=template&id=58ca7743&"
import script from "./MealrequestEdit.vue?vue&type=script&lang=js&"
export * from "./MealrequestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports